import { AbstractControl, ValidationErrors } from '@angular/forms';

/**
 *@description
 * Check that project
 * name doesn't have
 * special characters
 * @return {any}
 * @function
 */
export const projectNameHasNotSpecialCharacters = function () {
  return function (control: AbstractControl): ValidationErrors | null {
    return /^[.,():\s-_A-Za-z0-9]*$/.test(control.value) ? null : { hasSpecialCharacters: true };
  };
};



// WEBPACK FOOTER //
// ./src/app/shared/modals/modal-save/form-validators/project-name-has-not-special-characters.ts